module.exports = __webpack_public_path__ + "fonts/VetoSansCond-MediumItalic_1.12d92ddf.ttf";